<template>
  <div
    id="signout"
    v-bind:class="{
      'is-loading': state.isLoading,
      'open-modal': state.openModal
    }"
  >
    <div v-if="!state.formCompleted">
      <template v-if="signInCompleteHtml && $route.params.checkout">
        <span
          v-html="signInCompleteHtml"
          @click="clickOnSignInCompleteHtml($event)"
        />
      </template>
      <template v-else>
        <br />
        <h3 v-if="!isKiosk || $route.params.checkout">Would you like to sign out?</h3>
        <form-builder
          v-if="!$route.params.checkout"
          :steps="steps"
          :callback="submitViaMobile"
          :userData="userData"
          :hasBack="!$route.params.checkout"
          @back="goBack"
        ></form-builder>
        <div v-else class="btn-group">
          <button
            @click="submit()"
            class="appButton button-xlarge button-blue button is-primary margin-bottom"
          >
            <div class="loading"></div>
            {{ !isKiosk || $route.params.checkout ? "Signout" : "Continue" }}
          </button>
          <br/>
          <button @click="goBack" class="button mr-3">Back</button>
        </div>
        <br />
      </template>
    </div>
    <div v-if="state.formCompleted">
      <template>
        <br /><br /><br />
        <button
            @click="$router.push(`/${signInCode}`)"
            class="button-xlarge button-blue button is-primary margin-bottom"
          >
            Continue
          </button>
        </template>
      <br /><br /><br />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FormBuilder from "@/components/FormBuilder.vue";
import { getCheckInDataMixin } from "@/mixins.js";
export default {
  name: "Signout",
  mixins: [getCheckInDataMixin],
  components: { FormBuilder },
  data() {
    return {
      state: {
        openModal: false,
        isLoading: false,
        formCompleted: false,
        formCompletedMsg: "Signout Error"
      },
      steps: [
        {
          title: "Signout via Mobile",
          fields: [
            {
              type: "mobile",
              label: "Mobile",
              name: "mobile",
              rules: "required",
              value: null
            }
          ]
        }
      ],
      signInCompleteHtml: null
    };
  },
  computed: {
    currentStep() {
      return this.steps[this.state.activeStep];
    },
    isLastStep() {
      return this.state.activeStep === this.steps.length - 1;
    },
    signInCode() {
      const signInCode = localStorage.getItem("signInCode");
      const signInData = JSON.parse(localStorage.getItem("userFormSentData"));
      return signInCode || (signInData || {}).code;
    }
  },
  methods: {
    clickOnSignInCompleteHtml($event) {
      if ($event.srcElement && $event.srcElement.classList) {
          if ($event.srcElement.classList.contains("sign-out")) {
              this.submit();
          }
          else if ($event.srcElement.classList.contains("continue")) {
            this.goBack();
          }
      }

    },
    submit() {
      if (this.isKiosk && !this.$route.params.checkout) {
        return this.$router.push(`/${this.signInCode}`).catch(() => {})
      }

      let me = this;
      this.state.isLoading = true;
      this.showSubmitFeedback = true;
      this.removeMetaTagAppIcons();
      axios
        .post("/actions/" + this.$route.params.id, {
          //params: postData
        })
        .then(function(response) {
          console.log("signout Response", response);
          me.state.formCompleted = true;
          me.state.isLoading = false;
          if (response.data && response.data.success) {
            me.$parent.errorMsg = "";
            if (me.signInCompleteMessageDisplayTimeout) clearTimeout(me.signInCompleteMessageDisplayTimeout);
            me.$router.push({
              name: "signout-success",
              params: {
                message: response.data.message || "You are now signed out"
              }
            });
          } else {
            me.$parent.errorMsg = "Undefined Error";
            console.log("signout Response fail");
          }
        })
        .catch(function(error) {
          console.log(error);
          me.$parent.errorMsg = error;
          if (error.response.data && error.response.data.message) {
            me.$parent.errorMsg = error.response.data.message;
          }
          me.state.isLoading = false;
        });
      /* setTimeout(() => {
        //this.showSubmitFeedback = false;
        this.state.formCompleted = true;
      }, 2000);
      */
    },
    submitViaMobile() {
      let me = this;
      me.state.isLoading = true;

      const signInCode = localStorage.getItem("signInCode");
      axios
        .post(`signout/${signInCode}`, {
          mobile: me.steps[0].fields[0].valueObj.e164
        })
        .then(({ data }) => {
          if (data && data.success) {
            me.$parent.errorMsg = "";
            me.$router.push({
              name: "signout-success",
              params: {
                message: data.message || "You are now signed out"
              }
            });
          }
        })
        .catch(error => {
          me.$parent.errorMsg = error;
          if (error.response.data && error.response.data.message) {
            me.$parent.errorMsg = error.response.data.message;
          }
          me.state.isLoading = false;
        });
    },
    getDataCallback(responseData) {
      const { action, visit } = responseData;
      if (action === 'checkout' && visit) {
        this.steps[0].fields[0].value = visit.visitor.mobile;
      }
    },
    goBack() {
      if (this.signInCompleteMessageDisplayTimeout) clearTimeout(this.signInCompleteMessageDisplayTimeout);
      this.$router.push(`/${this.signInCode}`);
    },
    removeMetaTagAppIcons() {
      console.log("removeMetaTagAppIcons >>> ");
      try {
        const signInCode = localStorage.getItem("signInCode");
        var elms = document.querySelectorAll(`#${signInCode}`);
        elms.forEach(elm => {
          elm.parentNode.removeChild(elm);
        })
      } catch (err) {
        console.error("removeMetaTagAppIcons >>> ", err);
      }
    }
  },
  mounted() {
    console.log('TEST', this.$route.params.checkout, this.$route)
    let {signInCompleteMessageDisplayTime} = this.$root.location || {};
    signInCompleteMessageDisplayTime = signInCompleteMessageDisplayTime ? signInCompleteMessageDisplayTime : 5000;
    console.log("signInCompleteMessageDisplayTime >>> ", signInCompleteMessageDisplayTime);

    if (this.$route.params.checkout) {
      const signInCode = this.signInCode;
      if (this.isKiosk) {
        localStorage.removeItem("userVisitorData");
        this.signInCompleteMessageDisplayTimeout = setTimeout(() => {
          this.$router.push(`/${signInCode || ""}`);
        }, signInCompleteMessageDisplayTime);
      }
    }
  },
  created() {
    console.log("location >>> ", this.$root.location);
    if (!this.$route.params.checkout && !this.$root.location) {
      this.getCheckInData(this.$route.params.id, this.getDataCallback, null);
    }

    var signinCompleteMessage = (this.$root.location || {}).signInCompleteMessage ? (this.$root.location || {}).signInCompleteMessage : ((this.$root.location || {}).branding || {}).signInCompleteMessage;
    this.signInCompleteHtml = signinCompleteMessage ? signinCompleteMessage : this.signInCompleteHtml;
    console.log('signInCompleteHtml', this.signInCompleteHtml);
  }
};
</script>

<style lang="scss"></style>
